




















import { Vue, Prop } from "vue-property-decorator";
import Component from "vue-class-component";
@Component({})
export default class Table extends Vue {
  //tableData: [{id: 0, 'name': 'Max', 'lastname': 'Mustermann'}, {...}]
  @Prop() tableData!: [];
  items = [];
  search = "";
  column = "";

  mounted() {
    this.items = this.tableData;
    return null;
  }

  get cols(): string[] {
    return this.items.length >= 1 ? Object.keys(this.items[0]) : [];
  }

  get rows(): string[] | [] {
    if (!this.items.length) {
      return [];
    }

    return this.items.filter((item: any) => {
      let props =
        this.search && this.column ? [item[this.column]] : Object.values(item);
      return props.some(
        (prop) =>
          !this.search ||
          (typeof prop === "string"
            ? prop.includes(this.search)
            : prop.toString(10).includes(this.search))
      );
    });
  }
}
